import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import '../App.css';

const Topnav = () => {
	return (
		<header className="sticky-toolbar">
			<nav>
				<div className="pages-nav">
					<a href="#work">Work</a>
					<a href="#about">About</a>
					<a href="#cv">CV</a>
					<a
						className="nav-social"
						href="https://www.linkedin.com/in/noora-jumppanen/"
						target="_blank"
						rel="noopener noreferrer"
						aria-label="Noora's LinkedIn profile"
					>
						<FontAwesomeIcon icon={faLinkedin} />
					</a>
				</div>
			</nav>
		</header>
	);
};

export default Topnav;
